/**
 * Единица биржевой суммы: $ или шер, тем что человек вбивает в калькулятор.
 *
 * Купон ждёт штуки. Касса считает баксы. Оба числа честные, и человек сам
 * выбирает, какое держать: клик по знаку циклит, как валюта у конторы.
 */

import type { ExchangeStake } from '../lib/row';

export function ShareUnitEdit({
  as,
  onPick,
}: {
  as: ExchangeStake;
  onPick: (next: ExchangeStake) => void;
}): React.ReactElement {
  const next: ExchangeStake = as === 'usd' ? 'share' : 'usd';
  const usd = as === 'usd';
  return (
    <span className="nx-cur nx-cur--mark">
      <button
        type="button"
        className="nx-cur__mark"
        aria-label={usd ? 'сейчас доллары, нажать — шеры' : 'сейчас шеры, нажать — доллары'}
        title={usd ? 'сейчас доллары, нажать — шеры' : 'сейчас шеры, нажать — доллары'}
        onClick={(event) => {
          event.stopPropagation();
          onPick(next);
        }}
      >
        {usd ? '$' : 'шер'}
      </button>
    </span>
  );
}
